import { render, staticRenderFns } from "./StoreTransfers.vue?vue&type=template&id=5dc8d0f6"
import script from "./StoreTransfers.vue?vue&type=script&lang=js"
export * from "./StoreTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports